export const getters = {
  getOverride: $state => teamId => {
    return $state.records[teamId] || null;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};
